import React, { Suspense } from 'react';
import lazyWithRetry from 'utils/lazyWithRetry';
import Login from 'pages/login/Login';
import NotFound from 'components/404';
import Loader from 'wrapper/loader';

const Documents = lazyWithRetry(() => import('pages/documents'));
const Tools = lazyWithRetry(() => import('pages/tools'));
const Profile = lazyWithRetry(() => import('pages/profile'));
const Pipeline = lazyWithRetry(() => import('pages/pipeline'));
const Onboarding = lazyWithRetry(() => import('pages/onboarding/Onboarding'));
const Dashboard = lazyWithRetry(() => import('pages/dashboard'));
const ConsumerOnboard = lazyWithRetry(() => import('pages/auth/ConsumerOnboard'));

const consumerRoutes = [
  {
    path: '/',
    element: <Login />,
    children: [
      {
        path: 'documents',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Documents />
          </Suspense>
        ),
      },
      {
        path: 'tools',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Tools />
          </Suspense>
        ),
      },
      {
        path: 'onboarding',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Onboarding />
          </Suspense>
        ),
      },
      {
        path: 'onboard',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <ConsumerOnboard />
          </Suspense>
        ),
      },
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: 'profile',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Profile />
          </Suspense>
        ),
      },
      {
        path: 'pipeline',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Pipeline />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default consumerRoutes;
